module.exports = "<div class=popover-quote-activity> <quote-activity quote=quote></quote-activity> </div> ";